import { render, staticRenderFns } from "./MenuItemCom.vue?vue&type=template&id=21172f1f&"
import script from "./MenuItemCom.vue?vue&type=script&lang=ts&"
export * from "./MenuItemCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports